(function () {
  try {
    // Change this handle if your collection URL is different
    var isAuctionCollection =
      window.location.pathname.indexOf('/collections/auction') === 0 ||
      window.location.pathname.indexOf('/collections/all-auctions') === 0 ||
      window.location.pathname.indexOf('/collections/auctions') === 0;

    if (isAuctionCollection) {
      document.body.classList.add('ups-auction-collection');
    }
  } catch(e) {}
})();
